import comp from "./Body";
export default comp;
